import { configureStore } from '@reduxjs/toolkit'
import app from './app'
import user from './user'
export const store = configureStore({
  reducer: {
    app,
    user,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})
